import React from 'react';

// Yeniden kullanılan onboarding adımlarının üstüne konan renkli yönlendirme
// bloğu: ikon + başlık + açıklama. Saf sunum bileşeni.
const WizardGuide = ({icon = 'pi pi-info-circle', title, children, color = '#2563eb', bg = '#eff6ff'}) => (
    <div style={{display: 'flex', gap: 12, alignItems: 'flex-start', background: bg,
                 border: `1px solid ${color}22`, borderRadius: 10, padding: '14px 16px', marginBottom: 18}}>
        <span style={{width: 34, height: 34, borderRadius: 9, background: '#fff', color: color, flexShrink: 0,
                      display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <i className={icon} style={{fontSize: '1.1rem'}}/>
        </span>
        <div style={{minWidth: 0}}>
            {title && <div style={{fontWeight: 700, color: '#111827', marginBottom: 4}}>{title}</div>}
            <div style={{color: '#374151', fontSize: '.9rem', lineHeight: 1.5}}>{children}</div>
        </div>
    </div>
);

export default WizardGuide;
